<style lang="scss">
.site-list-wrapper {
  width: 288px;
  box-shadow: 3px 0px 4px rgba(0, 0, 0, 0.04);
  background: #fff;
  padding: 16px 16px 0 16px;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
  > h1 {
    font-weight: normal;
    font-size: 16px;
    margin: 0 0 17px 0;
    padding-bottom: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(230, 230, 230, 1);
  }
  > .site-wrapper {
    > .site {
      cursor: pointer;
      margin-bottom: 16px;
      canvas {
        pointer-events: none;
      }
    }
  }
}
</style>

<template>
  <div class="site-list-wrapper" v-loading="loading">
    <h1>
      站点列表
      <a href="javascript:void(0)"
        v-ui-permission="'addSite'"
        tars="id=45"
        class="cool-btn-primary el-icon-circle-plus-outline"
        @click="handleOpen">
        添加站点
      </a>
    </h1>
    <div class="site-wrapper">
      <div class="site" v-for="site in siteList" :key="site.id">
        <SiteTofu :site="site" @edit="handleOpen" />
      </div>
    </div>

    <SiteAdd
      v-if="siteAddVisible"
      :siteActive="siteActive"
      @update="updateEvent"
      :siteAddVisible.sync="siteAddVisible"
    />
  </div>
</template>

<script>
import request from '@/utils/request.js'
import SiteTofu from '@/components/SiteTofu.vue'
import SiteAdd from './SiteAdd.vue'
export default {
  components: {
    SiteTofu,
    SiteAdd
  },
  data () {
    return {
      siteAddVisible: false,
      siteList: [],
      siteActive: {},
      loading: false
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    async search () {
      this.loading = true
      let res = await request.get('/site/getCurrentUserSiteList')
      this.siteList = res.data
      this.loading = false
    },
    handleOpen (site) {
      this.siteActive = {}
      if (_.get(site, 'id')) {
        this.siteActive = site
      }
      this.siteAddVisible = true
    },
    updateEvent () {
      this.search()
    }
  }
}
</script>
